import { Line, Bar, Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';

// Chart.js'i kaydet
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const defaultOptions = {
  responsive: true,
  maintainAspectRatio: false
};

export function LineChart({ data, options, height = 280 }) {
  const resolvedHeight = typeof height === 'number' ? `${height}px` : height;
  return (
    <div style={{ height: resolvedHeight, width: '100%' }}>
      <Line data={data} options={{ ...defaultOptions, ...(options || {}) }} />
    </div>
  );
}

export function BarChart({ data, options, height = 280 }) {
  const resolvedHeight = typeof height === 'number' ? `${height}px` : height;
  return (
    <div style={{ height: resolvedHeight, width: '100%' }}>
      <Bar data={data} options={{ ...defaultOptions, ...(options || {}) }} />
    </div>
  );
}

export function DoughnutChart({ data, options, plugins, height = 240 }) {
  const resolvedHeight = typeof height === 'number' ? `${height}px` : height;
  return (
    <div style={{ height: resolvedHeight, width: '100%' }}>
      <Doughnut data={data} options={{ ...defaultOptions, ...(options || {}) }} plugins={plugins} />
    </div>
  );
} 